import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'antd/lib/form/Form';
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Table,
  Tag,
  Typography
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import {
  fetchsClientAccountsHandler,
  selectClientAccounts
} from '../../../redux/settings/carriersSlice';
import { selectCurUser } from '../../../redux/user/userSlice';
import { Country, COUNTRY_NAMES } from '../../../shared/utils/constants';

// 删除原有的 LabelUrlItem 和 Labels 接口

// 新增接口定义
interface LogisticsPrice {
  priceNo: string;
  logisticsName: string;
  estimatedDays: string;
  estimatedFreight: number;
  error?: string;
}

interface RateResponseData {
  timestamp: string;
  channelId: string;
  totalAmt: string;
  currency: string;
  logisticsPrices: LogisticsPrice[];
}

// 服务选项
const SERVICE_OPTIONS = [
  { label: '升降门送货', value: '升降门送货' },
  { label: '送货预约', value: '送货预约' },
  { label: '住宅送货', value: '住宅送货' },
  { label: '室内送货', value: '室内送货' },
  { label: ' 限制区域送货', value: ' 限制区域送货' }
];

const SERVICE_OPTIONSS = [
  { label: '升降门提货', value: '升降门提货' },
  { label: '住宅提货', value: '住宅提货' },
  { label: '室內提货', value: '室內提货' },
  { label: '限制区域取货', value: '限制区域取货' }
];

// 包裹类型选项
const PACKAGE_TYPE_OPTIONS = [
  { label: '托盘48×40', value: '1' },
  { label: '托盘48×48', value: '2' },
  { label: '托盘自定尺寸', value: '3' },
  { label: '包', value: '4' },
  { label: '箱', value: '5' }
];

enum UnitMeasure {
  LbIn = 0,
  LbKg = 1
}

const CardOrderPage = () => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const clientAccounts = useSelector(selectClientAccounts);
  const user = useSelector(selectCurUser);

  const clientToken = user.apiToken;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRateModalVisible, setIsRateModalVisible] = useState(false);
  const [rateData, setRateData] = useState<RateResponseData | null>(null);
  const [packageRows, setPackageRows] = useState([{ key: 0 }]);

  // 添加包裹信息行
  const addPackageRow = () => {
    setPackageRows([...packageRows, { key: packageRows.length }]);
  };

  // 移除包裹信息行
  const removePackageRow = (index: number) => {
    const newRows = [...packageRows];
    newRows.splice(index, 1);
    setPackageRows(newRows);
  };

  useEffect(() => {
    dispatch(fetchsClientAccountsHandler());
    if (clientToken) {
      form.setFieldsValue({
        token: clientToken
      });
    }
  }, [dispatch, form, clientToken]);

  // 重置表单
  const resetForm = () => {
    form.resetFields();
    if (clientToken) {
      form.setFieldsValue({
        token: clientToken
      });
    }
    setPackageRows([{ key: 0 }]);
  };

  // 处理运费弹框确定按钮点击
  const handleRateModalOk = () => {
    setIsRateModalVisible(false);
    resetForm();
  };

  // 提交到运费计算接口
  const OnSubmit = () => {
    if (isSubmitting) {
      message.warning('请勿重复提交');
      return;
    }

    form
      .validateFields()
      .then(async (values) => {
        setIsSubmitting(true);

        try {
          // 处理包裹信息 - 添加价格和数量
          const packageList1 =
            values.packageItems?.map(
              (item: {
                itemNam: any;
                totalValue: any;
                quantity: any;
                weights: any;
                length: any;
                width: any;
                height: any;
                unitMeasure: any;
                unitPrice: any; // 新增单价字段
                itemQuantity: any; // 新增数量字段
                packageType: any;
              }) => ({
                weight: Number(item.weights),
                packageType: item.packageType,
                lineItems: [
                  {
                    name: item.itemNam,
                    totalValue: Number(item.unitPrice),
                    quantity: Number(item.itemQuantity) // 使用用户输入的数量
                  }
                ],
                ...(item.length && { length: Number(item.length) }),
                ...(item.width && { width: Number(item.width) }),
                ...(item.height && { height: Number(item.height) }),
                ...(item.unitMeasure && {
                  unitMeasure: Number(item.unitMeasure)
                })
              })
            ) || [];

          // 准备提交到运费计算接口的数据
          const rateApiData = {
            token: clientToken,
            channelId: values.channel,
            test: false,
            // 添加服务项
            deliveryServices: values.deliveryServices || [],
            pickupServices: values.pickupServices || [],
            shipTo: {
              name: values.receiverName,
              phone: values.receiverPhone,
              email: values.receiverEmail || '',
              address1: values.receiverAddress1,
              address2: values.receiverAddress2 || '',
              city: values.receiverCity,
              state: values.receiverProvince,
              country: values.country,
              zipCode: values.receiverZip
            },
            packageList: packageList1
          };

          console.log('提交到运费计算接口的数据:', rateApiData);

          // 发送到运费计算API
          const response = await fetch('https://api.eksshipping.com/api/rate', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(rateApiData)
          });

          const result = await response.json();

          if (response.ok) {
            // 显示运费计算结果弹框
            setRateData(result);
            setIsRateModalVisible(true);
          } else {
            message.error(`运费计算失败: ${result.message || '未知错误'}`);
          }
        } catch (error) {
          console.error('提交出错:', error);
          message.error('提交过程中出现错误');
        } finally {
          setIsSubmitting(false);
        }
      })
      .catch((errorInfo) => {
        console.log('表单验证失败:', errorInfo);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Col span={12}>
            {/* 删除了订单号字段 */}
            <Form.Item
              name="receiverName"
              label="联系人"
              rules={[{ required: true, message: '请输入联系人' }]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item
              name="receiverPhone"
              label="电话"
              rules={[{ required: true, message: '请输入电话' }]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item name="receiverEmail" label="邮箱">
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item
              name="receiverAddress1"
              label="地址1"
              rules={[{ required: true, message: '请输入地址1' }]}
            >
              <Input.TextArea placeholder="请输入" />
            </Form.Item>
            <Form.Item name="receiverAddress2" label="地址2">
              <Input.TextArea placeholder="请输入" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="物流渠道"
              name="channel"
              rules={[{ required: true, message: '需要物流渠道' }]}
            >
              <Select>
                {clientAccounts
                  // 筛选出关联账号为KAPAI的渠道（假设关联账号信息存储在carrierName字段）
                  .filter((account) => account.connectedAccount === 'KAPAI')
                  .map((account) => (
                    <Select.Option key={account.id} value={account.accountId}>
                      {account.accountId} {/* 显示KAPAI关联的渠道号 */}
                    </Select.Option>
                  ))}
                {/* 如果没有找到KAPAI关联的渠道，显示提示 */}
                {clientAccounts.filter(
                  (account) => account.connectedAccount === 'KAPAI'
                ).length === 0 && (
                  <Select.Option value="" disabled>
                    暂无卡派服务
                  </Select.Option>
                )}
              </Select>
            </Form.Item>
            <Form.Item
              label="国家"
              name="country"
              initialValue={Country.USA}
              rules={[{ required: true, message: '需要国家' }]}
            >
              <Select>
                <Select.Option value={Country.USA}>
                  {COUNTRY_NAMES[Country.USA]}
                </Select.Option>
                <Select.Option value={Country.CHINA}>
                  {COUNTRY_NAMES[Country.CHINA]}
                </Select.Option>
                <Select.Option value={Country.AUSTRALIA}>
                  {COUNTRY_NAMES[Country.AUSTRALIA]}
                </Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="receiverProvince"
              label="省份"
              rules={[{ required: true, message: '请输入省份' }]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item
              name="receiverCity"
              label="城市"
              rules={[{ required: true, message: '请输入城市' }]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item
              name="receiverZip"
              label="邮编"
              rules={[{ required: true, message: '请输入邮编' }]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
          </Col>
        </Row>

        {/* 新增服务项 */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="pickupServices" label="提货服务">
              <Select
                mode="multiple"
                placeholder="请选择提货服务"
                options={SERVICE_OPTIONSS}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="deliveryServices" label="收货服务">
              <Select
                mode="multiple"
                placeholder="请选择收货服务"
                options={SERVICE_OPTIONS}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* 包裹信息（修改：添加价格和数量字段） */}
        <Form.Item label="包裹信息">
          <Table
            dataSource={packageRows}
            pagination={false}
            scroll={{ x: 1000 }}
            columns={[
              {
                title: '包裹类型',
                dataIndex: 'packageType',
                width: 150,
                render: (_, record, index) => (
                  <Form.Item
                    name={[`packageItems`, index, `packageType`]}
                    rules={[{ required: true, message: '请选择包裹类型' }]}
                    style={{ margin: 0 }}
                  >
                    <Select
                      placeholder="请选择包裹类型"
                      style={{ width: '100%' }}
                    >
                      {PACKAGE_TYPE_OPTIONS.map((option) => (
                        <Select.Option key={option.value} value={option.value}>
                          {option.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )
              },
              {
                title: '物品名称',
                dataIndex: 'itemNam',
                width: 150,
                render: (_, record, index) => (
                  <Form.Item
                    name={[`packageItems`, index, `itemNam`]}
                    rules={[{ required: true, message: '请输入物品名称' }]}
                    style={{ margin: 0 }}
                  >
                    <Input placeholder="请输入" />
                  </Form.Item>
                )
              },
              {
                title: '价值',
                dataIndex: 'unitPrice',
                width: 100,
                render: (_, record, index) => (
                  <Form.Item
                    name={[`packageItems`, index, `unitPrice`]}
                    rules={[{ required: true, message: '请输入价值' }]}
                    style={{ margin: 0 }}
                  >
                    <InputNumber
                      min={0}
                      step={0.01}
                      placeholder="价值"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                )
              },
              {
                title: '数量',
                dataIndex: 'itemQuantity',
                width: 100,
                render: (_, record, index) => (
                  <Form.Item
                    name={[`packageItems`, index, `itemQuantity`]}
                    rules={[{ required: true, message: '请输入数量' }]}
                    style={{ margin: 0 }}
                  >
                    <InputNumber
                      min={1}
                      placeholder="数量"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                )
              },
              {
                title: '重量',
                dataIndex: 'weights',
                width: 100,
                render: (_, record, index) => (
                  <Form.Item
                    name={[`packageItems`, index, `weights`]}
                    rules={[{ required: true, message: '请输入总重量' }]}
                    style={{ margin: 0 }}
                  >
                    <InputNumber
                      min={0.01}
                      step={0.01}
                      placeholder="重量"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                )
              },
              {
                title: '长',
                dataIndex: 'length',
                width: 80,
                render: (_, record, index) => (
                  <Form.Item
                    name={[`packageItems`, index, `length`]}
                    style={{ margin: 0 }}
                  >
                    <InputNumber
                      min={0}
                      step={0.1}
                      placeholder="长"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                )
              },
              {
                title: '宽',
                dataIndex: 'width',
                width: 80,
                render: (_, record, index) => (
                  <Form.Item
                    name={[`packageItems`, index, `width`]}
                    style={{ margin: 0 }}
                  >
                    <InputNumber
                      min={0}
                      step={0.1}
                      placeholder="宽"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                )
              },
              {
                title: '高',
                dataIndex: 'height',
                width: 80,
                render: (_, record, index) => (
                  <Form.Item
                    name={[`packageItems`, index, `height`]}
                    style={{ margin: 0 }}
                  >
                    <InputNumber
                      min={0}
                      step={0.1}
                      placeholder="高"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                )
              },
              {
                title: '单位',
                dataIndex: 'unitMeasure',
                width: 100,
                render: (_, record, index) => (
                  <Form.Item
                    name={[`packageItems`, index, `unitMeasure`]}
                    initialValue={UnitMeasure.LbIn}
                    style={{ margin: 0 }}
                  >
                    <Select style={{ width: '100%' }}>
                      <Select.Option value={UnitMeasure.LbIn}>
                        lb,in
                      </Select.Option>
                      <Select.Option value={UnitMeasure.LbKg}>
                        lb,kg
                      </Select.Option>
                    </Select>
                  </Form.Item>
                )
              },
              {
                title: '操作',
                width: 80,
                fixed: 'right',
                render: (_, record, index) => (
                  <Button
                    type="primary"
                    danger
                    size="small"
                    onClick={() => removePackageRow(index)}
                    disabled={packageRows.length === 1}
                  >
                    删除
                  </Button>
                )
              }
            ]}
            footer={() => (
              <Button
                type="dashed"
                onClick={addPackageRow}
                icon={<PlusOutlined />}
                block
              >
                添加物品
              </Button>
            )}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            onClick={OnSubmit}
            loading={isSubmitting}
            disabled={isSubmitting}
            size="large"
            style={{ width: 120 }}
          >
            {isSubmitting ? '提交中...' : '提交'}
          </Button>
        </Form.Item>
      </Form>

      {/* 运费计算弹框 */}
      <Modal
        title="运费计算结果"
        visible={isRateModalVisible}
        onOk={handleRateModalOk}
        cancelButtonProps={{ style: { display: 'none' } }}
        okText="确定"
        width={700}
      >
        {rateData && (
          <div>
            <div
              style={{
                marginBottom: '16px',
                padding: '12px',
                backgroundColor: '#f5f5f5',
                borderRadius: '6px'
              }}
            >
              <p>
                <strong>计算时间:</strong>{' '}
                {new Date(rateData.timestamp).toLocaleString()}
              </p>
              <p>
                <strong>渠道ID:</strong> {rateData.channelId}
              </p>
              <p>
                <strong>总金额:</strong>{' '}
                <Tag color="green" style={{ fontSize: '16px' }}>
                  {rateData.currency} {rateData.totalAmt}
                </Tag>
              </p>
            </div>

            <h4>物流价格列表:</h4>
            <Table
              dataSource={rateData.logisticsPrices}
              pagination={false}
              rowKey="priceNo"
              columns={[
                {
                  title: '物流商',
                  dataIndex: 'logisticsName',
                  key: 'logisticsName',
                  width: 120
                },
                {
                  title: '预估天数',
                  dataIndex: 'estimatedDays',
                  key: 'estimatedDays',
                  width: 100,
                  render: (days) => <Tag color="blue">{days}</Tag>
                },
                {
                  title: '预估运费',
                  dataIndex: 'estimatedFreight',
                  key: 'estimatedFreight',
                  width: 120,
                  render: (freight) => <Tag color="green">${freight}</Tag>
                },
                {
                  title: '状态',
                  key: 'status',
                  width: 100,
                  render: (_, record: LogisticsPrice) =>
                    record.error ? (
                      <Tag color="red">不可用</Tag>
                    ) : (
                      <Tag color="success">可用</Tag>
                    )
                },
                {
                  title: '错误信息',
                  key: 'error',
                  render: (_, record: LogisticsPrice) => (
                    <Typography.Text
                      type={record.error ? 'danger' : 'secondary'}
                    >
                      {record.error || '无错误'}
                    </Typography.Text>
                  )
                }
              ]}
            />
          </div>
        )}
      </Modal>
    </>
  );
};
export default CardOrderPage;
